import React, { useEffect, Dispatch } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from 'react-router-dom';
import './Announcements.css'
import Divider from '@material-ui/core/Divider';
import { getAnnouncements, getAnnouncementDetail } from '../../store/actions/announcements.actions';

const Announcements: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();
  const { announcements }: any = useSelector((state: any) => state.announcements);
  const history = useHistory();

  useEffect(() => {
    if (!announcements)
      dispatch(getAnnouncements());
  }, [announcements, dispatch]);

  // Filter announcements based on announcement_type
  const filteredOffersList = announcements?.data?.data?.Offers?.OffersList?.filter((item: any) =>
    item.announcement_type === "" || item.announcement_type === "general_announcement"
  ) || [];

  return (
    <>
      <h5 className="page-sub-title mb-2">Announcements</h5>
      <div className="cardCommon height-400">
        {filteredOffersList.length > 0 ? (
          filteredOffersList.map((item: any) => (
            <div className="col-12 mt-3" key={item.id}>
              <Link to="/announcements" onClick={(e) => {
                e.preventDefault();
                dispatch(getAnnouncementDetail(item.id, item.name));
                history.push('/announcements');
              }} className="ml-3 mr-2 mt-2 section-title">{item.name}</Link>
              <div className="ml-3 mr-2 mt-1 section-content text-ellipsis">{item.description}</div>
              {item.date &&
                <div className="ml-3 mr-2 mt-2 section-date"> {item.date}</div>
              }
              <Divider className="mt-3 mb-2" />

            </div>
          ))) : (
          <div className="d-flex justify-content-center align-items-center h-100 p-4">
            <img
              src="/announcement.png"   // ✅ your image from public folder
              alt="No Announcements"
              style={{ width: "auto", overflow: "hidden", opacity: 0.8 }}
              // onClick={() => history.push('/announcements')}
            />
          </div>
        )}
      </div>
    </>
  )
}

export default Announcements